<template>
  <div class="events-wrapper">
    <div v-if="isEventsLoading">
      <generic-loading-skeleton />
    </div>
    <div v-else>
      <div class="d-flex justify-content-between pb-2">
        <div><h2>Events</h2></div>
        <edit-event-interests-button
          class="pt-1"
          :topics="topics"
          :showSubtitle="true"
          @interestsSaved="resetEventsFeed"
        ></edit-event-interests-button>
      </div>
      <div v-if="events && events.length > 0">
        <div class="pt-1">
          <div v-for="event in events" :key="event.id">
            <div class="pb-2 pl-1">
              <event-card :event-data="event"></event-card>
            </div>
          </div>
        </div>
      </div>
      <div v-else>No events to display</div>
      <div class="d-flex justify-content-between">
        <router-link
          :to="{ path: 'events' }"
          @click.native="trackViewAllEvent()"
          class="view-all-link"
        >
          <span>View all</span>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import * as CONSTANTS from "@/store/constants";
import EventCard from "./EventCard";
import GenericLoadingSkeleton from "../GenericLoadingSkeleton";
import HomebaseMixpanelMixin from "@/mixins/HomebaseMixpanelMixin";
import EditEventInterestsButton from "@/components/homebase/buttons/EditEventInterestsButton";

export default {
  name: "events",
  mixins: [HomebaseMixpanelMixin],
  components: {
    EventCard,
    GenericLoadingSkeleton,
    EditEventInterestsButton,
  },
  data() {
    return {
      CONSTANTS,
      events: null,
      topics: null,
      isEventsLoading: true,
      allEventsLink: CONSTANTS.ALL_EVENTS_LINK,
    };
  },
  created() {
    this.getEvents();
  },
  methods: {
    async getEvents() {
      this.isEventsLoading = true;
      try {
        let res = await api.getEventsByInterest(0, 2);
        this.events = res.data.data.eventsByInterest.events.events;
        this.topics = res.data.data.eventsByInterest.topics;
      } catch (e) {
        console.log(e);
      } finally {
        this.isEventsLoading = false;
      }
    },

    isLastIndex(arr, index) {
      if (!arr) return false;
      let lastIndex = arr.length - 1;
      return index === lastIndex;
    },

    resetEventsFeed() {
      this.events = [];
      this.topics = null;
      this.getEvents();
    },

    trackViewAllEvent() {
      this.trackViewAllClick('View all events selected');
    },
  },
};
</script>

<style scoped>
.events-wrapper {
  padding-bottom: 50px;
}

.add-event-link {
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  text-decoration: none;
}

.add-event-link:hover {
  color: var(--secondary-color-hover);
  text-decoration: none;
}
</style>


// WEBPACK FOOTER //
// src/components/homebase/events/Events.vue